import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const ConfettiOverlay = styled('div', {
  base: {
    position: 'fixed',
    inset: '0',
    pointerEvents: 'none',
    overflow: 'hidden',
    zIndex: '120',
  },
})

const ConfettiOrigin = styled('div', {
  base: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '0',
    height: '0',
  },
})

const Piece = styled(motion.span, {
  base: {
    position: 'absolute',
    top: '0',
    left: '0',
    display: 'block',
    transformOrigin: 'center',
    willChange: 'transform, opacity',
  },
  variants: {
    shape: {
      square: { borderRadius: '2px' },
      rectangle: { borderRadius: '1px' },
      circle: { borderRadius: '50%' },
      streamer: { borderRadius: '999px' },
    },
  },
  defaultVariants: {
    shape: 'square',
  },
})

export { ConfettiOverlay, ConfettiOrigin, Piece }
